/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const OrderDetail = () => {
  return (
    <div className="dashboard_content">
      <div className="dashboard_body">
        <h3>invoice</h3>
        <div className="invoice">
          <a className="go_back" href="">
            <i className="fas fa-long-arrow-alt-left" /> go back
          </a>
          {/* <div className="track_order">
            <ul>
              <li className="active">order pending</li>
              <li>order accept</li>
              <li>order process</li>
              <li>on the way</li>
              <li>Completed</li>
            </ul>
          </div> */}
          <div className="invoice_header">
            <div className="header_address">
              <h4>invoice to</h4>
              <p>
                7232 Broadway Suite 308, Jackson Heights, 11372, NY, United
                States
              </p>
              <p>+1347-430-9510</p>
            </div>
            <div className="header_address">
              <p>
                <b>invoice no: </b>
                <span>4574</span>
              </p>
              <p>
                <b>Order ID:</b> <span> #4789546458</span>
              </p>
              <p>
                <b>date:</b> <span>10-11-2022</span>
              </p>
            </div>
          </div>
          <div className="invoice_body">
            <div className="table-responsive">
              <table className="table table-striped">
                <tbody>
                  <tr className="border_none">
                    <th className="sl_no">SL</th>
                    <th className="package">item description</th>
                    <th className="price">Price</th>
                    <th className="qnty">Quantity</th>
                    <th className="total">Total</th>
                  </tr>
                  <tr>
                    <td className="sl_no">01</td>
                    <td className="package">
                      <p>Hyderabadi Biryani</p>
                      <span className="size">small</span>
                      <span className="coca_cola">coca-cola</span>
                      <span className="coca_cola2">7up</span>
                    </td>
                    <td className="price">
                      <b>$120</b>
                    </td>
                    <td className="qnty">
                      <b>2</b>
                    </td>
                    <td className="total">
                      <b>$240</b>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td className="package" colSpan={3}>
                      <b>sub total</b>
                    </td>
                    <td className="qnty">
                      <b>12</b>
                    </td>
                    <td className="total">
                      <b>$755</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="package coupon" colSpan={3}>
                      <b>(-) Discount coupon</b>
                    </td>
                    <td className="qnty">
                      <b />
                    </td>
                    <td className="total coupon">
                      <b>$0.00</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="package coast" colSpan={3}>
                      <b>(+) Shipping Cost</b>
                    </td>
                    <td className="qnty">
                      <b />
                    </td>
                    <td className="total coast">
                      <b>$10.00</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="package" colSpan={3}>
                      <b>Total Paid</b>
                    </td>
                    <td className="qnty">
                      <b />
                    </td>
                    <td className="total">
                      <b>$765</b>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <a className="print_btn common_btn" href="#">
            <i className="fas fa-long-arrow-alt-left" /> go back
          </a>
        </div>
      </div>
    </div>
  );
};

export default OrderDetail;
